
export default (num, length) => {

    let numString = String(num);
    while(numString.length < length){
        numString = "0" + numString;
    }

    return numString;
}